{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "בחר פריט",
  "tableResizer": "שינוי גודל"
}
